<template>
  <div
    class="overlay"
    @click="$emit('cancel')"
  />
  <div class="modal-wrapper">
    <div class="flex gap-4">
      <div class="modal-icon warning">
        <WarningIcon />
      </div>
      <div>
        <h2 class="modal-heading">
          Oops! You haven’t selected any properties for this widget.
        </h2>
        <p class="modal-content mt-1">
          This means the “Specials” feature will be turned off. Do you want to continue?
        </p>
      </div>
    </div>

    <div class="flex gap-4 self-end">
      <button
        class="btn-secondary is-btn-size-default min-w-[100px]"
        @click="$emit('confirm')"
      >
        Yes
      </button>
      <button
        class="btn-primary is-btn-size-default min-w-[100px]"
        @click="$emit('cancel')"
      >
        No
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import WarningIcon from "../icons/WarningIcon.vue";

export default defineComponent({
  name: "PropertyWarningModal",
  components: {
    WarningIcon,
  },
  emits: ['cancel', 'confirm'],
});
</script>

<style scoped>
.overlay {
  @apply fixed top-0 left-0 z-40 w-full h-full bg-black/50;
}

.modal-wrapper {
  @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50
  flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-xl;
}

.modal-icon {
  @apply flex justify-center items-center flex-shrink-0 w-12 h-12 rounded-sm;
}
</style>
